module.exports = __webpack_public_path__ + "static/media/short-haired-girl.1cd1548f.png";